import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import './NotFound.css'

export default function NotFound() {
  const location = useLocation()

  return (
    <main style={{ paddingTop: '80px' }}>
      <section className="section not-found">
        <div className="container not-found__inner">
          <span className="badge">404</span>
          <h1>
            This route isn't <span className="text-accent">deployed</span>
          </h1>
          <p>
            <code className="not-found__path">{location.pathname}</code> doesn't match any page.
            It may have moved, or the link is out of date.
          </p>
          <div className="not-found__actions">
            <Link to="/" className="btn btn--primary">Back to Home</Link>
            <Link to="/services" className="btn btn--outline">View Services</Link>
          </div>
        </div>
      </section>
    </main>
  )
}
